// extracted by mini-css-extract-plugin
export default {"currentPrice":"pricelabel_currentPrice__RR1uH","previousPrice":"pricelabel_previousPrice__9C3tG","discountBanner":"pricelabel_discountBanner__jLkDf"};